import { gql } from "@apollo/client";
import { productListingAllFieldsFragment } from "./CommonQueries";
import { ProductListing } from "../../../common/models";
import { ProductListingUpdateInput } from "../../../common/inputs/ProductListingInput";
import {
    BaseMutationTuple,
    BaseQueryResult,
    useBaseMutation,
    useBaseQuery
} from "./index";

const productListingQuery = gql`
    ${productListingAllFieldsFragment}
    query productListing($id: String!) {
        productListing(id: $id) {
            ...ProductListingAllFields
        }
    }
`;

const updateProductListingMutation = gql`
    ${productListingAllFieldsFragment}
    mutation updateProductListing($data: ProductListingUpdateInput!) {
        updateProductListing(data: $data) {
            ...ProductListingAllFields
        }
    }
`;

export const useProductListingQuery = (id: string): BaseQueryResult<ProductListing> => {
    return useBaseQuery<ProductListing, { productListing: ProductListing }>(
        productListingQuery,
        {id},
        ({data}) => data.productListing,
    );
};

export const useUpdateProductListingMutation = (): BaseMutationTuple<ProductListingUpdateInput, ProductListing> => {
    const transformInput = (input: ProductListingUpdateInput) => ({ data: input });
    const transformOutput = (output: any): ProductListing => output.updateProductListing;
    return useBaseMutation<ProductListingUpdateInput, ProductListing>(
        updateProductListingMutation,
        transformInput,
        transformOutput,
    );
};
